import API from "../components/helpers/endpointservice";
import Actions from './api';
import { jwtDecode } from 'jwt-decode';
import {  Loader, Login } from '../action/LoginActions';

export const CreateAccountapi = (data) => {
  
  return async (dispatch) => {
    //Loader true
    dispatch({ type: "IS_LOADER", data: true });
    await  Actions.POST(`${API.CREATE_ACCOUNT}`, data).then((res) => {
      if (res.data !== undefined && res.status==200) {
        dispatch({ type: "CREATE_ACCOUNT_SUCCESS", data: res.data });
        window.location.href = '/emailverification';
        localStorage.setItem("userNameTAC",data.email)
      }
      //Loader false
      dispatch({ type: "IS_LOADER", data: false });
    }).catch((error) => {
      //Loader false
      dispatch({ type: "IS_LOADER", data: false });
    });
  }
};

// export const verifyEmail = (data) => {
//   
//     return (dispatch) => {
//       //Loader true
//       dispatch({ type: "IS_LOADER", data: true });
//       Actions.POST(`${API.VERIFY_EMAIL}`, data).then(async (res) => {
        
//         if (res.data !== undefined && res.status==200) {
//           dispatch({ type: "VERIFY_EMAIL_SUCCESS", data: res.data });
//           console.log(res.data.key);
//           let value=res.data.key;
//           let key={
//             "secretKey": value
//           }
//           // RegisterKeycloak(key)
//           // dispatch({ type: "IS_LOADER", data: true });
//           Actions.POST(`${API.CREATE_ACCOUNT_REGISTER_KEYCLOAK}`, key).then((res) => {
//             if (res.data !== undefined && res.status==200) {
//               dispatch({ type: "REGISTER_KEYCLOAK_SUCCESS", data: res.data });
//             }
//             //Loader false
//             dispatch({ type: "IS_LOADER", data: false });
//           }).catch((error) => {
//             //Loader false
//             dispatch({ type: "IS_LOADER", data: false });
//           });
//         }
//         else{
//           
//           let errormsg='INVALID OTP';
//           localStorage.setItem('invalidotp',errormsg)
//         }
//         //Loader false
//         dispatch({ type: "IS_LOADER", data: false });
//       })
//       .then((res)=>{
       
//       })
//       .catch((error) => {
//         //Loader false
//         dispatch({ type: "IS_LOADER", data: false });
//       });
//     }
//   };


//     export const verifyEmail = (data) => {
//       return (dispatch) => {
//         // Loader true
//         dispatch({ type: "IS_LOADER", data: true });
//     // First API call to verify email
//     Actions.POST(`${API.VERIFY_EMAIL}`, data)
//       .then((res) => {
//         if (res.data !== undefined && res.status === 200) {
//           
//           // Dispatch action for successful email verification
//           dispatch({ type: "VERIFY_EMAIL_SUCCESS", data: res.data });
//           console.log(res.data.key);
//           let value = res.data.key;
//           let key = {
//             "secretKey": value
//           };
//           // let design='employee'
//           dispatch({ type: "IS_LOADER", data: false });
//           // dispatch({ type: "IS_REGISTER_LOAD", data: true });
//           // localStorage.removeItem('invalidotp')
//           // // Start registering with Keycloak
//           return Actions.POST(`${API.CREATE_ACCOUNT_REGISTER_KEYCLOAK}`, key);
//           // return Actions.POST(`${API.CREATE_ACCOUNT_REGISTER_KEYCLOAKMOCK}?type=${design}`, key)
//         }
//          else {
//           // 
//           // // Handle invalid OTP case
//           // let errormsg = 'INVALID OTP';
//           // localStorage.setItem('invalidotp', errormsg);
//           // throw new Error('Invalid OTP');
//         }
//       })
//       .then((res) => {
//         // Second API call success: Register with Keycloak
//         // if (res.data !== undefined && res.status === 200) {
//           // window.location.href = '/users';
//           // dispatch({ type: "REGISTER_KEYCLOAK_SUCCESS", data: res.data });
//           // dispatch({ type: "IS_REGISTER_LOAD", data: false });
//           //  console.log(res.data.token.accessToken);
//           //  const rawToken=res.data.token.accessToken;
//           //  const decodedToken = jwt_decode(res.data.token.accessToken);
//           //  console.log(decodedToken); // This will log the decoded token object
//           //  console.log(decodedToken.user_role); // Access the user_role from the decoded token
       
//            // Store the access token in localStorage
//           //  
//           //  localStorage.setItem('AccessToken',rawToken);
//           //  localStorage.setItem('Role',decodedToken.user_role);
//           // //  localStorage.setItem('isLogin',true);
//           //  localStorage.setItem('realmName',decodedToken.tenant_id)
//           //  localStorage.setItem('userName',decodedToken.email)
//           //  dispatch({ type: "IS_LOGIN", data:true });
//           //  if(decodedToken.user_role=="Admin"){
//           //   window.location.href = '/users';
//           //  }
//           //  else{
//           //   window.location.href = '/homepage';
//           //  }
//         // }
//       })
//       .catch((error) => {
//         // Handle errors for both API calls
//         
//         console.error('Error:', error);
//         dispatch({ type: "VERIFY_EMAIL_SUCCESS", data: error.response.data });

//         let errormsg = error.response?.data?.message || 'INVALID OTP';
//         localStorage.setItem('invalidotp', errormsg);
//       })
//       .finally(() => {
//         // Loader false after both API calls complete
//         dispatch({ type: "IS_LOADER", data: false });
//         // dispatch({ type: "IS_REGISTER_LOAD", data: false });
//       });
//   };
// };


// Action creator for verifying email and registering with Keycloak
export const verifyEmail = (data) => {
  return (dispatch) => {
    // Set loader to true
    dispatch({ type: "IS_LOADER", data: true });

    // First API call to verify email
    Actions.POST(API.VERIFY_EMAIL, data)
      .then((res) => {
        if (res.data !== undefined && res.status === 200) {
          // Dispatch action for successful email verification
          dispatch({ type: "VERIFY_EMAIL_SUCCESS", data: res.data });

          // Extract key from response data
          let value = res.data.key;
          let key = {
            "secretKey": value
          };

          // Return Promise for second API call to register with Keycloak
          dispatch({ type: "IS_LOADER", data: false });
          return Actions.POST(API.CREATE_ACCOUNT_REGISTER_KEYCLOAK, key);
        } else {
         
        }
      })
      .then((res) => {
        // Second API call success: Register with Keycloak
        if (res.data !== undefined && res.status === 200) {
          // Handle success response (if needed)
          // For example:
          // dispatch({ type: "REGISTER_KEYCLOAK_SUCCESS", data: res.data });

          // Redirect or perform additional actions (if needed)
          // Example redirection:
          // if (decodedToken.user_role === "Admin") {
          //   window.location.href = '/users';
          // } else {
          //   window.location.href = '/homepage';
          // }
        }
      })
      .catch((error) => {
        // Handle errors for the first API call
        console.error('Error in verifyEmail:', error);
        console.log(error.response.data);
        dispatch({ type: "VERIFY_EMAIL_SUCCESS", data: error.response.data || 'Error occurred' });
      })
      .finally(() => {
        // Turn off loader after both API calls complete
        dispatch({ type: "IS_LOADER", data: false });
      });
  };
};


  export const ResendOtp = () => {
    
    let data=localStorage.getItem('userNameTAC')
    let value={
        "email": data
    }
    
    return async (dispatch) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      await  Actions.POST(`${API.RESEND_OTP}`,value).then((res) => {
        if (res.data !== undefined && res.status==200) {
          dispatch({ type: "OTP_RESEND_SUCCESS", data: res.data });
          
        }
        //Loader false
        dispatch({ type: "IS_LOADER", data: false });
      }).catch((error) => {
        //Loader false
        dispatch({ type: "IS_LOADER", data: false });
      });
    }
  };

  export const RegisterKeycloak = (data) => {
    
    return async (dispatch) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      await  Actions.POST(`${API.CREATE_ACCOUNT_REGISTER_KEYCLOAK}`, data).then((res) => {
        if (res.data !== undefined && res.status==200) {
          dispatch({ type: "REGISTER_KEYCLOAK_SUCCESS", data: res.data });
        }
        //Loader false
        dispatch({ type: "IS_LOADER", data: false });
      }).catch((error) => {
        //Loader false
        dispatch({ type: "IS_LOADER", data: false });
      });
    }
  };

  export const RegisterKeycloakMock = (data) => {
    
    return async (dispatch) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
        //MOCK API
        await Actions.POST(`${API.CREATE_ACCOUNT_REGISTER_KEYCLOAKMOCK}?type=admin`)
        .then((res) => {
          if (res.data !== undefined && res.status === 200) {
            
            let design='admin'
            dispatch({ type: "REGISTER_KEYCLOAK_SUCCESS", data: res.data });
            console.log(res);
            const rawToken=res.data.accessToken;
            const rawRefreshToken=res.data.refreshToken;
                   const decodedToken = jwtDecode(res.data.accessToken);
                   console.log(decodedToken); // This will log the decoded token object
                   localStorage.setItem('AccessTokenTAC',rawToken);
                   localStorage.setItem('RefreshTokenTAC',rawRefreshToken);
             localStorage.setItem('RoleTAC',decodedToken.user_role);
            //  localStorage.setItem('isLogin',true);
             localStorage.setItem('realmNameTAC',decodedToken.tenant_id)
             localStorage.setItem('userNameTAC',decodedToken.email)
            dispatch({ type: "IS_LOGIN", data:true });
            // window.location.href = "/users";
            window.location.href = "/admin/users";
          }
           else {
            
            // Handle invalid OTP case
            let errormsg = 'INVALID OTP';
            localStorage.setItem('invalidotpTAC', errormsg);
            throw new Error('Invalid OTP');
          }
        })
        .catch((error) => {
          // Handle errors for both API calls
          
          console.error('Error:', error);
          dispatch({ type: "VERIFY_EMAIL_SUCCESS", data: error.response.data });
  
          let errormsg = error.response?.data?.message || 'INVALID OTP';
          localStorage.setItem('invalidotpTAC', errormsg);
        })
        .finally(() => {
          // Loader false after both API calls complete
          dispatch({ type: "IS_LOADER", data: false });
          dispatch({ type: "IS_REGISTER_LOAD", data: false });
        });
    }
  };


  

  